const kitStatuses = Object.freeze({
  ASSIGNED: 'ASSIGNED',
  PROCESSING: 'PROCESSING',
  UNASSIGNED: 'UNASSIGNED',
  REQUESTED: 'REQUESTED',
  ALLOCATED: 'ALLOCATED',
  DISPATCHED_BY_MICROBA: 'DISPATCHED_BY_MICROBA',
  RECEIVED_BY_CUSTOMER: 'RECEIVED_BY_CUSTOMER',
  RECEIVED_BY_MICROBA: 'RECEIVED_BY_MICROBA',
  RESULTS_AVAILABLE: 'RESULTS_AVAILABLE',
  MICROBIOME_COACH_SESSION_COMPLETED: 'RESULTS_AVAILABLE',
  REPLACED: 'REPLACED',
  FAILED_OVERLOADED: 'FAILED_OVERLOADED',
  FAILED_UNDERLOADED: 'FAILED_UNDERLOADED',
  FAILED_SWAB_OTHER: 'FAILED_SWAB_OTHER',
  FAILED_PROCESSING: 'FAILED_PROCESSING',
  REDEEMED: 'REDEEMED',
  INVALIDATED: 'INVALIDATED'
})

const kitAvailableTip = 'This kit has not been shipped and is ready for you to request it to be sent out.'
const sentTip = 'This kit has been shipped to you via Australia Post, you should receive it within 3-6 business days.'

const kitStatusesDetails = Object.freeze({
  ASSIGNED: kitAvailableTip,
  PROCESSING: 'We are processing your sample, it takes approximately 4 weeks from receiving your sample at our laboratory to have your Microba Insight Report ready.',
  UNASSIGNED: kitAvailableTip,
  REQUESTED: 'This kit is being prepared for dispatch by the Microba team and will be sent as soon as possible.',
  ALLOCATED: sentTip,
  DISPATCHED_BY_MICROBA: sentTip,
  RECEIVED_BY_MICROBA: 'We have received your sample at our laboratory. It will take approximately 4 weeks from receipt for your Microba Insight Report to be ready.',
  RESULTS_AVAILABLE: `Your Microba Insight Report is ready, please go to the 'Reports' button using the bar to the left hand side of your screen.`,
  REPLACED: '',
  FAILED_OVERLOADED: 'We have sent you an email regarding your sample, please check your email inbox.',
  FAILED_UNDERLOADED: 'We have sent you an email regarding your sample, please check your email inbox.',
  FAILED_SWAB_OTHER: 'We have sent you an email regarding your sample, please check your email inbox.',
  INVALIDATED: 'This kit has been invalidated.'
})

const kitStatusLabels = Object.freeze({
  ASSIGNED: 'Kit Available',
  PROCESSING: 'Processing',
  UNASSIGNED: 'Kit Available',
  REQUESTED: 'Packing',
  ALLOCATED: 'Sent',
  DISPATCHED_BY_MICROBA: 'Sent',
  RECEIVED_BY_CUSTOMER: 'Received',
  RESULTS_AVAILABLE: 'Results Available',
  REPLACED: 'Replaced',
  FAILED_OVERLOADED: 'Error',
  FAILED_UNDERLOADED: 'Error',
  FAILED_SWAB_OTHER: 'Error',
  FAILED_PROCESSING: 'Error',
  REDEEMED: 'Kit Redeemed',
  INVALIDATED: 'INVALIDATED'
})

export {
  kitStatuses,
  kitStatusesDetails,
  kitStatusLabels
}



// WEBPACK FOOTER //
// ./src/enums/kitItemStatus.js